import { ScrollbarOptions } from 'smooth-scrollbar/interfaces';

export const scrollbarOptions: ScrollbarOptions = {
  damping: 0.2,
  thumbMinSize: 20,
  renderByPixels: true,
  alwaysShowTracks: false,
  continuousScrolling: true,
  wheelEventTarget: null,
  plugins: null,
  delegateTo: null
};



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/scrollbar/scrollbar-options.ts